module.exports = __webpack_public_path__ + "static/media/cosmetics2.cee448c7.png";